import { render, staticRenderFns } from "./EditSuperAdminComponent.vue?vue&type=template&id=b755a7b6&"
import script from "./EditSuperAdminComponent.vue?vue&type=script&lang=js&"
export * from "./EditSuperAdminComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports